import usersDetailComponent from './users-detail.component';

const usersDetailModule = angular
  .module('usersDetail', [])
  .component('usersDetail', usersDetailComponent);

export default usersDetailModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users-detail/users-detail.js
 **/